module.exports = __webpack_public_path__ + "static/media/dynamic_tags_icon.d51be79c.png";